/**
 * Where floating UI (popovers, menus, dialogs, tooltips) portals to. Normally
 * `document.body`; a host that moves the whole app into ANOTHER document —
 * the extension's "Keep on top" floating window (Document Picture-in-Picture)
 * — points it at that document's body, so a menu opened in the floating
 * window opens IN the floating window rather than in the tab it came from.
 *
 * A plain module switch rather than React context on purpose: the portal
 * call sites sit after early returns in a dozen primitives, and the app only
 * ever lives in one document at a time.
 */
let container: HTMLElement | null = null

export function setPortalContainer(next: HTMLElement | null): void {
  container = next
}

/** The current portal target — the override while set, else `document.body`. */
export function getPortalContainer(): HTMLElement {
  return container?.isConnected ? container : document.body
}
